<template>
      <v-card hover flat>
          <v-card-title>
            <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
            <label for="male">SERVICIO ELECTRÓNICO</label>

                <div class="v-input__control">
                    <div class="v-input__slot">
                        <div class="v-text-field__slot">
                            <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto</label>
                            <vue-numeric v-model="se" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                        </div>
                    </div>
                </div>
            </div>
          </v-card-title>
          <v-card-text style="padding: 0">
                <v-data-table
                    :headers="headers"
                    :items="document_requirements"
                    hide-actions
                >
                <template v-slot:items="props">
                
                    <td>
                        {{ props.item.name }}
                    </td>

                    <td>
                        <v-edit-dialog
                            v-if="props.item.name == 'ASEGURAMIENTO' || props.item.name == 'COMPILACION' || props.item.name == 'OTRAS ACTUACIONES'"
                            :return-value.sync="props.item.monto_n"
                            lazy
                            large
                            @save="save"
                            save-text="Guardar"
                            @cancel="cancel"
                            cancel-text="Cerrar"
                            @open="open"
                            @close="close"
                        >
                            <div><vue-numeric currency="BsS" v-model="props.item.monto_n" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric></div>
                            <template v-slot:input>
                                <div class="mt-3 title">Actualizar</div>
                            </template>
                            <template v-slot:input>
                                <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                                    <div class="v-input__control">
                                    <div class="v-input__slot">
                                        <div class="v-text-field__slot">
                                        <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto Natural</label>
                                        <vue-numeric v-model="props.item.monto_n" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </template>
                        </v-edit-dialog>
                    </td>
                
                    <td>
                        <v-edit-dialog
                            v-if="props.item.name != 'ASEGURAMIENTO'"
                            :return-value.sync="props.item.monto_j"
                            lazy
                            large
                            @save="save"
                            save-text="Guardar"
                            @cancel="cancel"
                            cancel-text="Cerrar"
                            @open="open"
                            @close="close"
                        >
                            <div><vue-numeric currency="BsS" v-model="props.item.monto_j" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric></div>
                            <template v-slot:input>
                                <div class="mt-3 title">Actualizar</div>
                            </template>
                            <template v-slot:input>
                                <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                                    <div class="v-input__control">
                                    <div class="v-input__slot">
                                        <div class="v-text-field__slot">
                                        <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto Juridica</label>
                                        <vue-numeric v-model="props.item.monto_j" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </template>
                        </v-edit-dialog>    
                    </td>

                </template>
                </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" class="primary" @click="enviarMontosNuevos">Actualizar</v-btn>
        </v-card-actions>

        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn flat @click="snack = false">Cerrar</v-btn>
        </v-snackbar>

        <v-dialog v-model="loading" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                Porfavor Espere...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-card>
</template>
<script>
import axios from 'axios'
import VueNumeric from 'vue-numeric'

export default {
    components: {
        VueNumeric
    },
    data () {
      return {
        loading: false,
        snack: false,
        se: 0,
        snackColor: '',
        snackText: '',
        max25chars: v => v.length <= 25 || 'muy largo!',
        pagination: {},
        headers: [
          { text: 'DOCUMENTO', align: 'left', sortable: false, value: 'name' },
          { text: 'MONTO NATURAL', align: 'left', sortable: false , value: 'monto_n' },
          { text: 'MONTO JURIDICA', align: 'left', sortable: false , value: 'monto_j' }
        ],
        document_requirements: []
      }
    },
    mounted() {
        this.searchDocumentRequireds()
    },
    methods: {
        async enviarMontosNuevos () {
            this.loading = true
            await axios.post(`/api/document_types/document-new-price`, { data: this.document_requirements, se: this.se })
                .then(res => {
                    this.cerrarDialog(res.data)
                })
                .catch(e => {
                    console.log(e.response.data)
                    if(e.response.data.error){
                        this.error(e.response.data.error)
                    }
                })
                .finally(() => this.loading = false);
        },
        async searchDocumentRequireds () {
            this.loading = true
            await axios.get(`/api/document_types/document-types-definition`)
                .then(res => {
                    let arreglo = res.data.dt
                    arreglo.forEach(element => Object.assign(element,{ monto_n: '', monto_j: '' }));
                    // arreglo.push({ name: 'SERVICIO ELECTRONICO', monto_n: '', monto_j: '' });
                    this.document_requirements = arreglo
                })
                .finally(() => this.loading = false);
        },
        save () {
            this.snack = true
            this.snackColor = 'success'
            this.snackText = 'Monto Agregado'
        },
        cancel () {
            this.snack = true
            this.snackColor = 'error'
            this.snackText = 'Cancelado'
        },
        open () {
            this.snack = true
            this.snackColor = 'info'
            this.snackText = 'Dialogo abierto'
        },
        error (message) {
            this.snack = true
            this.snackColor = 'error'
            this.snackText = message
        },
        close () {
            console.log('Dialogo cerrado')
        },
        cerrarDialog (data) {
            this.$emit('closeDialog', data)
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/formNuevosMontos.vue